import { Card } from '@sainsburys-tech/luna-card'
import { Container } from '@sainsburys-tech/luna-react'
import { ISummary } from '../../../../../types/ComponentTypes/Components'
import ComponentSwitch from '../..'
import { formatCurrency } from '../../../../../utils/formatCurrency'

const productValue = 'product_value'
const productName = 'product_name'
const equipmentName = 'equipment_name'

function SummaryComponent({
  data,
  components,
  controls,
  placeholder,
  error
}: ISummary) {
  const ErrorMessage = ({ message }: any) => {
    return (
      <Container className="ln-c-field-info ln-c-field-info--error ln-u-padding-bottom*3">
        {message}
      </Container>
    )
  }

  if (data == null || data == "") {
    return (
      <>
        <Card className="s-summary-placeholder">
          {placeholder}
        </Card>
        {error ? <ErrorMessage message={error} /> : null }
      </>
    )
  }

  const summaryData = JSON.parse(data)

  const formatCurrencyAndConcatEach = (value: string) => {
    const currencyFormattedValue = formatCurrency(value)
    return `${currencyFormattedValue} each`
  }

  return (
    <div>
      {Object.keys(summaryData).map(key => {
        const summaryItem = summaryData[key]
        return (
          <>
            <Card className="s-summary-box">
              {components.map((component: any, index: number) => {
                return (
                  <ComponentSwitch
                    {...component}
                    value={
                      component.id === productValue
                      ? formatCurrencyAndConcatEach(summaryItem[component.id])
                      : component.id !== productName && component.id !== equipmentName
                        ? summaryItem[component.id]
                        : `${summaryItem[component.value]} x ${summaryItem[component.id]}`
                    }
                    key={component.id + key + index}
                  />
                )
              })}
              {controls.map((control: any, index: number) => {
                return <ComponentSwitch {...control} response={key} key={control.id + key + index} />
              })}
            </Card>
          </>
        )
      })}
      {error ? <ErrorMessage message={error} /> : null }
    </div>
  )
}

export default SummaryComponent
